import React, { PropsWithChildren } from 'react';
import { WidgetHeading } from './partials/WidgetHeading';
import { WidgetIcon } from './partials/WidgetIcon';
import { WidgetTitle } from './partials/WidgetTitle';
import { WidgetHeader } from './partials/WidgetHeader';
import { WidgetType } from '../../../types/api/ElementType';
import { SVGIcon } from '../../../components/atoms/SVG';
import { Widget } from './Widget';
import { getWidgetHeaderId } from './Widget.utils';
import { HeadingHierarchy } from '../Heading/Heading';

type DefaultWidgetHeaderProps = {
  widgetType: WidgetType;
  hierarchy?: HeadingHierarchy;
  uuid: string;
  icon: SVGIcon;
  title: string;
  header?: boolean;
};

export function DefaultWidgetWithHeader({
  widgetType,
  hierarchy = 2,
  uuid,
  icon,
  title,
  children,
  header,
}: PropsWithChildren<DefaultWidgetHeaderProps>) {
  return (
    <Widget header={header} uuid={uuid} widgetType={widgetType} aria-labelledby={getWidgetHeaderId(widgetType, uuid)}>
      <WidgetHeader>
        <WidgetHeading hierarchy={hierarchy}>
          <WidgetIcon icon={icon} />
          <WidgetTitle>{title}</WidgetTitle>
        </WidgetHeading>
      </WidgetHeader>
      {children}
    </Widget>
  );
}
